import {z} from 'zod';

export const PartDepartmentSettingDataSchema = z.object({
  branch_id: z.string(),
  service_order_type_id: z.string(),
  service_order_type_code: z.string(),
  service_order_type: z.string(),
  department_type_id: z.string(),
  department_type_name: z.string(),
});

export const GetPartDepartmentSettingDataResponseSchema = z.array(PartDepartmentSettingDataSchema);

export type GetPartDepartmentSettingDataResponse = z.infer<
  typeof GetPartDepartmentSettingDataResponseSchema
>;

export const GetPartDepartmentSettingDataApiArgSchema = z.object({
  branchId: z.string(),
});

export type GetPartDepartmentSettingDataApiArg = z.infer<
  typeof GetPartDepartmentSettingDataApiArgSchema
>;

export const PartDepartmentTypeSchema = z.object({
  departmentTypeId: z.string(),
  departmentTypeName: z.string(),
});

export const GetPartDepartmentTypesResponseSchema = z.array(PartDepartmentTypeSchema);

export type GetPartDepartmentTypesResponse = z.infer<typeof GetPartDepartmentTypesResponseSchema>;

export const PartDepartmentInsertItemSchema = z.object({
  branchId: z.string(),
  serviceOrderTypeId: z.string(),
  departmentTypeId: z.string(),
});

export const PartDepartmentInsertPayloadSchema = z.array(PartDepartmentInsertItemSchema);

export const PostPartDepartmentInsertApiArgSchema = z.object({
  body: PartDepartmentInsertPayloadSchema,
});

export type PostPartDepartmentInsertApiArg = z.infer<typeof PostPartDepartmentInsertApiArgSchema>;
